import { ButtonBase, Stack, Typography, useTheme } from "@mui/material";
import { Check, Star } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { InitialsAvatar } from "web_myplann/Shared/Components/InitialsAvatar";

type Props = {
	name: string;
	photo?: string;
	role?: string;
	unreadCount: number;
	isMain: boolean;
	isSelected: boolean;
	onClick: () => void;
};

export const AdvisorPickerRow: FC<Props> = ({
	name,
	photo,
	role,
	unreadCount,
	isMain,
	isSelected,
	onClick,
}) => {
	const theme = useTheme();
	const { t } = useResource();

	return (
		<ButtonBase
			aria-pressed={isSelected}
			onClick={onClick}
			sx={{
				width: "100%",
				justifyContent: "flex-start",
				gap: theme.spacingTokens.md,
				px: theme.spacingTokens.lg,
				py: theme.spacingTokens.md,
				bgcolor: isSelected ? theme.palette.blue[50] : "transparent",
				textAlign: "left",
			}}
		>
			<InitialsAvatar
				name={name}
				photo={photo}
				size={44}
				muted={!isSelected}
				initialsVariant="value"
			/>
			<Stack flex={1} minWidth={0}>
				<Stack
					direction="row"
					alignItems="center"
					gap={theme.spacingTokens.sm}
					flexWrap="wrap"
				>
					<Typography variant="bodyStrong" sx={{ overflowWrap: "anywhere" }}>
						{name}
					</Typography>
					{isMain && (
						<Star
							size={theme.iconSize.xs}
							fill={theme.palette.amber[400]}
							color={theme.palette.amber[400]}
						/>
					)}
				</Stack>
				{role && (
					<Typography
						variant="caption"
						color={theme.palette.grey[500]}
						sx={{ overflowWrap: "anywhere" }}
					>
						{role}
					</Typography>
				)}
				{unreadCount > 0 && (
					<Typography
						variant="button"
						color={theme.palette.blue[600]}
						sx={{ overflowWrap: "anywhere" }}
					>
						{t(Resources.Advisor.unreadMessages, { count: unreadCount })}
					</Typography>
				)}
			</Stack>
			{isSelected && (
				<Check size={theme.iconSize.md} color={theme.palette.blue[500]} />
			)}
		</ButtonBase>
	);
};
